var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00128 4.66659C6.00935 3.21657 6.07365 2.43129 6.58591 1.91904C7.1717 1.33325 8.11451 1.33325 10.0001 1.33325L10.6668 1.33325C12.5524 1.33325 13.4952 1.33325 14.081 1.91904C14.6668 2.50482 14.6668 3.44763 14.6668 5.33325L14.6668 10.6666C14.6668 12.5522 14.6668 13.495 14.081 14.0808C13.4952 14.6666 12.5524 14.6666 10.6668 14.6666L10.0001 14.6666C8.1145 14.6666 7.1717 14.6666 6.58591 14.0808C6.07365 13.5685 6.00935 12.7833 6.00128 11.3333",
    stroke: "#202D49",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8L1.33333 8M1.33333 8L3.66667 6M1.33333 8L3.66667 10",
    stroke: "#202D49",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.f2751390ba90fbb9ff547852d87202f3.svg";
export { ForwardRef as ReactComponent };